import { FC, useContext } from "react";

import { FormType } from "@simplyk/common";

import { FrontendFormContext } from "../../../../contexts/FrontendFormContext";
import { useFormV2Context } from "../../context/FormV2Context";

import { useTicketingFirstStepSubmit } from "./useTicketingFirstStepSubmit";

import { HeartsAnimationContext } from "@/features/FormV2/context/heartsAnimationContext";
import { HeartsFormButton } from "@/forms-design-system/HeartsFormButton";
import { useTranslate } from "@/hooks/useTranslate";
import { ArrowRight } from "@/icons/outlined";

export type TicketingV2CheckoutFooterProps = {
  totalTickets: number;
  hasDonation: boolean;
};

export const TicketingV2CheckoutFooter: FC<TicketingV2CheckoutFooterProps> = ({ totalTickets, hasDonation }) => {
  const { t } = useTranslate();
  const { isMembership } = useFormV2Context(FormType.Ticketing);
  const { onFirstStepSubmit, canSubmitFirstStep } = useTicketingFirstStepSubmit();
  const { shouldDisplayHeartsAnimation, animationKey } = useContext(HeartsAnimationContext);
  const { formCtaCopyResult } = useContext(FrontendFormContext);

  const label =
    totalTickets > 0
      ? isMembership
        ? formCtaCopyResult
          ? t("ticketing", "checkoutToPayment")
          : t("ticketing", "checkout")
        : formCtaCopyResult
          ? t("ticketing", "checkoutToPaymentWithCount", { count: totalTickets })
          : t("ticketing", "checkoutWithCount", { count: totalTickets })
      : hasDonation
        ? t("ticketing", "donate")
        : formCtaCopyResult
          ? t("ticketing", "checkoutToPayment")
          : t("ticketing", "checkout");

  return (
    <HeartsFormButton
      type="submit"
      endIcon={<ArrowRight />}
      onClick={onFirstStepSubmit}
      disabled={!canSubmitFirstStep}
      data-test="form-v2-step1-submit-button"
      animated={shouldDisplayHeartsAnimation}
      animationKey={animationKey}
      autoplay
      sx={() => ({
        boxShadow: "0px 16px 32px 0px rgba(0, 0, 0, 0.12)",
      })}
    >
      {label}
    </HeartsFormButton>
  );
};
